<div class="wrapper h-100" style="position: relative;">
  <div id="mainheader" class="pt-1">

    <!-- <app-header></app-header> 
    <app-breadcrumb></app-breadcrumb> -->
    <!-- <div class="overlay" (click)="dismissSidebar()"></div> -->
    <div class="wrapper-search-box">
    <div class="row d-flex p-0  m-0 justify-content-between justify-content-md-end ">
      <div class="col-2 col-xl-2 col-lg-2  p-0 d-flex  justify-content-end">
        <div class="all_tokens mb-2 mr-2" (click)="checkAllTokens()" id="all_tokens">
          <div class="container_chk align-self-center" style="position: absolute;top:8px;">
            <input type="checkbox" name="" [checked]="operator" [(ngModel)]="operator">
            <span class="checkmark" disabled></span>
          </div>
          <div class="align-self-center pl-4   d-none  d-md-flex">All Tokens</div>
        </div>
      </div>
      <div class="col-8 col-xl-8 col-lg-8  p-0 ">
        <div class="input-group input-group-content mb-3 p-0 custom-search-box" style="position: relative">
          <!-- <div class="input-group-prepend">
            <button class="btn btn-outline-secondary searchfield" *ngIf="!showMic" id="searchbtn" (click)="stopSpeech()"
              type="button">
              <i class="fas fa-microphone-slash"></i>
            </button>
            <button class="btn btn-outline-secondary searchfield" *ngIf="showMic" id="searchbtn"
              (click)="activateSpeech()" type="button">
              <i class="fas fa-microphone"></i></button>
          </div> -->
          <input
            type="text"
            class="form-control inputstyle"
            (keyup.enter)="searchFiles()"
            (keyup)="handleKeyUp($event)"
            [(ngModel)]="searchText"
            placeholder="Search by {{type}} by Deck Name, Contact Person, Description, Purpose, Related Tags..."
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          >
          <div class="input-group-append">
    <!-- Clear Button (cross icon) -->
     <div>
    <button *ngIf="searchText" type="button" class="btn clear-btn d-flex" (click)="clearSearch()">
      <span class="material-symbols-outlined">close</span>
    </button>
     </div>
            <div> 
              <button class="btn btn-outline-secondary searchfield-right d-flex" id="searchbtn" type="button" (click)="searchFiles()">
                <span class="material-symbols-outlined">search</span>
              </button>
            </div>
          </div>
          <!-- <div>
            <button class="btn search_btn msicon" id="text-search" type="button" (click)="searchFiles($event)">
                <span class="material-symbols-outlined">search</span>
            </button>
        </div> -->
        </div>
      </div>
      <div class="col-2 col-xl-2 col-lg-2 p-0  my-1 text-center">
      </div>
    </div>
    <!-- <nav aria-label="breadcrumb brdcrm">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item active brdcrml" aria-current="page" (click)="goToHome()">Home &nbsp;</li>

        <li class="breadcrumb-item active" style="cursor:pointer" (click)="switchDeckView()">KMS Portal &nbsp;</li>
        <li class="breadcrumb-item active" aria-current="page">{{type}}</li>
      </ol>
    </nav> -->
  
  </div>
  <!-- <div id="backset" style="height:45px;"></div> -->
</div>

  <div class="d-flex justify-content-between align-items-center p-2" >
    <div class="page_title align-self-center">{{type}} Overview </div>
    <div class="btn-group add_button"  *ngIf="!kmsViewer">
      <button type="button" data-reference="parent"
        class="btn btn-secondary w-100 add-btn" (click)="onChangeProjectType('Corporate Deck')"><i class="fas fa-plus"></i>Add {{type}} </button>
    </div>
  </div>

  <div *ngIf="(!allProjects || allProjects.ictProjects.length === 0) && !loading">
    <mat-card class="mt-3">
      <mat-card-content class="no-records custom_subtiles1 fs-16">No Records Found</mat-card-content>
    </mat-card>
  </div>

  <div class="row m-0 carporate-deck-cards"
    *ngIf="allProjects && allProjects.ictProjects.length > 0">

    <div class="col-xl-4 col-lg-4 col-md-6 card-b-space" *ngFor="let project of allProjects.ictProjects">

      <div class="card d-flex justify-content-end">
        <div *ngIf="project.restrictedContent" class="resticted-project">Restricted</div>

        <div class="d-flex flex-xl-row flex-column">
          <div
            class="card-left d-flex flex-xl-column flex-sm-row flex-column justify-content-xl-start justify-content-around">
            <img width="120" height="75" [src]="'data:image/jpg;base64,' + project.logoBase64">
            <div class="pl-2 ml-1">
              <div class="project-name mb-2" [ngbTooltip]="projectNameTooltip" placement="top" triggers="manual"
                #tooltip="ngbTooltip" (mouseleave)="tooltip.close()" (mouseover)="tooltip.open()">
                <ng-template #projectNameTooltip>{{project.projectName}}</ng-template>
                {{project.projectName}}
              </div>


              <div class=" mb-2">
                <div class="date-labels">Last updated on</div>
                <div class="date-value">{{project.updatedOn | date: 'short'}}</div>
              </div>
              <div class="">
                <div class="date-labels">Contact Person</div>
                <div class="date-value">{{project.contactPerson}}</div>
              </div>
            </div>
          </div>
          <div class="card-right">
            <div class="d-flex card-inner">
              <div class="icon-width-alignment">
                <img height="16" width="16" src="../../../assets/images/info.svg">
              </div>

              <div class="pl-2">
                <div class="date-labels">Description</div>
                <div class="date-value desc-wrap" tooltipClass="tooltip-wrap" [ngbTooltip]="projectDescription1"
                  placement="top bottom" triggers="manual" (click)="projectDescription.open()"
                  #projectDescription="ngbTooltip" (mouseleave)="projectDescription.close()"
                  (mouseover)="projectDescription.open()">
                  <ng-template #projectDescription1>{{project.description}}</ng-template>
                  {{project.description.length
                  <67?project.description:project.description.substring(0,64).concat("...")}} <!--
                    {{project.description.substring(0,60)}}{{"..."}} -->

                </div>
              </div>
            </div>
            <div class="d-flex card-inner">
              <div class="icon-width-alignment">
                <img height="16" width="16" src="../../../assets/images/purpose_icon.svg">
              </div>
              <div class=" pl-2">
                <div class="date-labels">Purpose</div>
                <div class="date-value desc-wrap" tooltipClass="tooltip-wrap" [ngbTooltip]="projectPurpose1"
                  placement="top bottom" triggers="manual" (click)="projectPurpose.open()" #projectPurpose="ngbTooltip"
                  (mouseleave)="projectPurpose.close()" (mouseover)="projectPurpose.open()">

                  <ng-template #projectPurpose1>{{project.purposeOfUsage}}</ng-template>
                  {{project.purposeOfUsage.length
                  <67?project.purposeOfUsage:project.purposeOfUsage.substring(0,44).concat("...")}} <!--
                    {{project.purposeOfUsage.substring(0,60)}}{{"..."}} -->
                </div>
              </div>
            </div>
            <div class="d-flex card-inner">
              <div class="icon-width-alignment">
                <img height="16" width="16" src="../../../assets/images/tags.svg">
              </div>
              <div class="pl-2">
                <div class="date-labels">Related Tags</div>
                <div class="date-value related-wrap" [ngbTooltip]="projectTagsTooltip" tooltipClass="tooltip-wrap"
                  placement="top bottom" triggers="manual" (click)="tooltipTags.open()" #tooltipTags="ngbTooltip"
                  (mouseleave)="tooltipTags.close()" (mouseover)="tooltipTags.open()">
                  <ng-template #projectTagsTooltip>{{project.tags}}</ng-template>
                  {{project.tags.length<67?project.tags:project.tags.substring(0,64).concat("...")}} <!--
                    {{project.tags.substring(0,60)}}{{"..."}} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end card-footer py-0 pr-0">
          <div>
            <i class="fas fa-eye px-bottom-icons pt-2 hideView" *ngIf="project.restrictedContent && kmsViewer" (click)="viewICTProject(project.fileURL,project.id)"></i>
            <i class="fas fa-eye px-bottom-icons pt-2" *ngIf="!project.restrictedContent && kmsViewer" (click)="viewICTProject(project.fileURL,project.id)"></i>
            <i class="fas fa-eye px-bottom-icons pt-2" *ngIf="(role!='Viewer' && !kmsViewer)" (click)="viewICTProject(project.fileURL,project.id)"></i>
            <i class="fas fa-download py-3 px-bottom-icons" *ngIf="!restrictDownloadAndMail && !kmsViewer"
              (click)="downloadICTProject(project)"></i>
            <i class="fas fa-pencil-alt px-bottom-icons pt-2"
              *ngIf="project.changesAllowed && role != 'Viewer' && !kmsViewer" (click)="editICTProject(project.id)"></i>
            <i class="fas fa-trash px-bottom-icons py-3" *ngIf="!kmsViewer"
              (click)="deleteICTProject(project.id)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>